import { render, staticRenderFns } from "./ModernAlert.vue?vue&type=template&id=f45c7136&scoped=true&"
import script from "./ModernAlert.vue?vue&type=script&lang=js&"
export * from "./ModernAlert.vue?vue&type=script&lang=js&"
import style0 from "./ModernAlert.vue?vue&type=style&index=0&id=f45c7136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45c7136",
  null
  
)

export default component.exports